export var getRootUrl = function (_a) {
    var apiRoot = _a.apiRoot, rootPath = _a.rootPath;
    return apiRoot + "/".concat(rootPath);
};
//# sourceMappingURL=getRootUrl.js.map